import Vue from 'vue'
import api from '../../api/api'
import * as types from "../mutation-types"

const user = {
  state: {
    user:{
      id:'',
      name:'',
      auth:[],
      school:{}
    },

    userList:[],
    userPage:{}
  },

  mutations: {
    [types.SET_USER_INFO](state,data) {
      state.user = data
    },

    [types.LOGOUT](state) {
      Vue.ls.remove('token')
    },

    [types.SET_USER_LIST](state,data) {
      state.userList = data.list
      state.userPage = {
        page:data.pageno,
        total:data.totalcount
      }
    }
  },

  getters: {
    isAdmin: state => {
      let is_admin = state.user.auth.find(item => item.authid == 1)
      if(is_admin) {
        return true
      } else {
        return false
      }
    },
    isSchoolAdmin: state => {
      return state.user.school.campusid ? true : false
    }
  },

  actions: {
    getUserInfo({ commit }) {
      let user = Vue.ls.get('user')
      if(user) {
        commit(types.SET_USER_INFO, user)
      }
      if(user.auth.length == 0) {
        Vue.prototype.$Message.error({
          content: '您当前没有操作权限，请联系管理员',
          duration: 0
        })
      }
      return user
    },

    async getUserList({ commit, rootState, getters, state }) {
      let params = Object.assign({},rootState.route.query)
      params.usertype = params.usertype || 1
      if(getters.isSchoolAdmin) {
        params.campusid = state.user.school.campusid
      } 
      let ret = await api.getUser(params)
      commit(types.SET_USER_LIST, ret.data)
      console.log('用户列表',ret)
    }
  }

};

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js